import React, { useState } from "react";
import thumbs from "./../assets/thumbs-up-down.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import {toast} from "react-toastify";
import CustomToastContainer from "../components/CustomToastContainer";
import { submitFeedback } from "../apiServices/apiServices";

const Feedback = () => {
  const navigate = useNavigate();
  const user = JSON.parse(window.localStorage.getItem("user"));

  const handleNavigation = (path) => {
    navigate(path);
  };

  const initialTags = [
    "Cleanliness",
    "Bad Bus Condition",
    "Driver's Misbehavior",
    "Reckless Driving",
    "Wrong Fare Deduction",
    "Over Speed",
    "System Outage",
    "Missing Stops",
  ];
  const [tags, setTags] = useState(
    initialTags.map((tag) => ({ name: tag, selected: false }))
  );
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const toggleTagSelection = (index) => {
    const updatedTags = tags.map((tag, i) =>
      i === index ? { ...tag, selected: !tag.selected } : tag
    );
    setTags(updatedTags);
  };

  const validateInputs = () => {
    let isValid = true;

    if (!subject.trim()) {
      isValid = false;
      toast.warn("Subject is required")
      return isValid;
    }
    if (!message.trim()) {
      isValid = false;
      toast.warn("Message is required")
      return isValid;
    }
    return isValid;
  };

  const handleSubmit = async () => {
    if (!validateInputs()) {
      return;
    }

    const selectedTags = tags
      .filter((tag) => tag.selected)
      .map((tag) => tag.name)
      .join(",");

    const feedbackData = {
      typeid: "0",
      passenger_id: user.id,
      type: selectedTags,
      subject: subject,
      details: message,
      is_active: "1",
      parent_id: "0",
      message_type: "feedback",
    };
    console.log("Submitting feedback:", feedbackData);

    try {
        const response = await submitFeedback(feedbackData );
        console.log("Response : ", response);
        if (response && response.success) {
          toast.success('Feedback submitted successfully!')
          setTags(initialTags.map((tag) => ({ name: tag, selected: false })))
          setMessage("")
          setSubject("")
        } else {
          toast.error(response.message || 'Request failed');
        }
      } catch (error) {
        console.error('Error:', error);
        toast.error('An error occurred. Please try again.');
      }

    
  };

  return (
    <>
        <div className="bg-gray-100 min-h-screen">
        {/* Header Section */}
        <nav className="fixed top-0 left-0 right-0 z-10 flex items-center justify-between p-2 sm:p-4 bg-white shadow-md">
            <button
            className="text-gray-600 items-center"
            onClick={() => handleNavigation(-1)}
            >
            <FontAwesomeIcon icon={faArrowLeft} size="lg" />
            </button>
            <div className="flex items-center justify-center flex-grow gap-2">
            <h1 className="text-gray-600 font-semibold text-lg">Feedback</h1>
            </div>
        </nav>

        {/* Scrollable Form Section */}
        <div className="pt-12 md:pt-15 overflow-y-auto">
            <div className="p-4">
            <div className="flex flex-col gap-6">
                {/* Icon and Heading */}
                <div className="flex items-start gap-4">
                <div className="w-30 h-30 rounded-full border border-gray-600 bg-gray-200 flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full overflow-hidden">
                    <img
                        src={thumbs}
                        alt="Feedback"
                        className="object-cover text-red-500 w-full h-full p-2"
                    />
                    </div>
                </div>
                <div>
                    <p className="text-gray-700 text-base">
                    Please share your feedback with details. Your feedback is
                    valuable to improve our service.
                    </p>
                    <p className="text-gray-500 text-sm mt-1">
                    PSBS is working round the clock to provide its customers with
                    reliable service.
                    </p>
                </div>
                </div>

                {/* Feedback Type */}
                <div>
                <label className="block text-gray-700 text-sm font-medium">
                    FEEDBACK TYPE:
                </label>
                <div className="flex flex-wrap gap-2 mt-2">
                    {tags.map((tag, index) => (
                    <span
                        key={index}
                        className={`px-4 py-1 text-sm rounded-md cursor-pointer border border-[#be1f18] ${
                        tag.selected
                            ? "bg-[#be1f18] text-white"
                            : "bg-red-50 text-[#be1f18]"
                        }`}
                        onClick={() => toggleTagSelection(index)}
                    >
                        {tag.name}
                    </span>
                    ))}
                </div>
                </div>

                {/* Subject */}
                <div>
                <label className="block text-gray-700 text-sm font-medium">
                    SUBJECT:
                </label>
                <input
                    type="text"
                    placeholder="I Lost My Card"
                    maxLength={30}
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    className="mt-2 w-full h-12 px-4 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring focus:ring-gray-300"
                />
                </div>

                {/* Message */}
                <div>
                <label className="block text-gray-700 text-sm font-medium">
                    MESSAGE:
                </label>
                <textarea
                    placeholder="Your message here..."
                    maxLength={200}
                    rows={5}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className="mt-2 w-full p-4 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring focus:ring-gray-300"
                ></textarea>
                </div>

                {/* Submit Button */}
                <button
                onClick={handleSubmit}
                className="w-full py-3 bg-red-500 text-white text-sm font-medium rounded-md hover:bg-red-600 focus:outline-none focus:ring focus:ring-red-200"
                >
                Submit
                </button>
            </div>
            </div>
        </div>
        </div>
        <CustomToastContainer/>
    </>
  );
};

export default Feedback;
